module.exports = __webpack_public_path__ + "img/zsgscl-1.6e06e9c8.jpg";